/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_headline_role_and_mission = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Engineer & Digital Architect. Je construis des solutions digitales à fort impact et forme les créateurs de demain.`)
};

const en_headline_role_and_mission = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Engineer & Digital Architect. I build high-impact digital solutions and train the creators of tomorrow.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const headline_role_and_mission = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.headline_role_and_mission(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("headline_role_and_mission", locale)
	if (locale === "fr") return fr_headline_role_and_mission(inputs)
	return en_headline_role_and_mission(inputs)
};